module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tiposEnvio/tiposEnvio.component.scss
// module id = ./src/app/tiposEnvio/tiposEnvio.component.scss
// module chunks = main